import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';

const productLinks = [
  { label: 'HealHub — Clinic Management', href: '/healhub' },
  { label: 'Suraksha — Anti Fraud App', href: '/suraksha' },
  { label: 'Vedant — AI Health Assistant', href: '/vedant' },
  { label: 'HealHub Nexus — Enterprise', href: '/healhub' },
  { label: 'All Products', href: '/products' },
];

const companyLinks = [
  { label: 'About Us', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Contact', href: '/contact' },
];

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Grievance Officer', href: '/grievance-officer' },
  { label: 'DPDP Act Compliance', href: '/dpdp-compliance' },
];

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: '#0D0D0D',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        paddingTop: '80px',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
        }}
      >
        {/* ── Top Grid ── */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: '48px',
            marginBottom: '64px',
          }}
          className="footer-grid"
        >
          {/* ── Brand Column ── */}
          <div>
            {/* Logo */}
            <Link
              to="/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                textDecoration: 'none',
                marginBottom: '20px',
              }}
            >
              <img
                src={logo}
                alt="Redcubical Systems"
                style={{
                  height: '52px',
                  width: '52px',
                  objectFit: 'contain',
                  borderRadius: '8px',
                }}
              />
              <span
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontWeight: '800',
                  fontSize: '16px',
                  color: '#fff',
                  lineHeight: 1.3,
                }}
              >
                Redcubical
                <span
                  style={{
                    display: 'block',
                    fontSize: '11px',
                    fontWeight: '500',
                    color: '#555',
                    letterSpacing: '0.5px',
                  }}
                >
                  Systems Pvt Ltd
                </span>
              </span>
            </Link>

            {/* Tagline */}
            <p
              style={{
                fontSize: '14px',
                lineHeight: '1.8',
                color: '#555',
                maxWidth: '280px',
                marginBottom: '28px',
              }}
            >
              Building software that protects lives, empowers
              healthcare, and creates a safer digital India.
            </p>

            {/* HealHub external link */}
            <a
              href="https://healhub.in"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px',
                fontWeight: '600',
                color: '#E63946',
                textDecoration: 'none',
                border: '1px solid rgba(230,57,70,0.3)',
                padding: '8px 16px',
                borderRadius: '50px',
                transition: 'all 0.2s',
                marginBottom: '16px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  'rgba(230,57,70,0.08)';
                e.currentTarget.style.borderColor =
                  'rgba(230,57,70,0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor =
                  'rgba(230,57,70,0.3)';
              }}
            >
              🏥 Visit HealHub.in ↗
            </a>

            {/* India flag */}
            <p
              style={{
                fontSize: '13px',
                color: '#444',
                marginTop: '8px',
              }}
            >
              🇮🇳 Made with purpose in India
            </p>
          </div>

          {/* ── Products Column ── */}
          <div>
            <p
              style={{
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#444',
                marginBottom: '20px',
              }}
            >
              Products
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              {productLinks.map((item) => (
                <Link
                  key={item.href + item.label}
                  to={item.href}
                  style={{
                    fontSize: '14px',
                    color: '#666',
                    textDecoration: 'none',
                    transition: 'color 0.2s',
                    lineHeight: '1.4',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = '#fff')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = '#666')
                  }
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* ── Company Column ── */}
          <div>
            <p
              style={{
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#444',
                marginBottom: '20px',
              }}
            >
              Company
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              {companyLinks.map((item) => (
                <Link
                  key={item.href + item.label}
                  to={item.href}
                  style={{
                    fontSize: '14px',
                    color: '#666',
                    textDecoration: 'none',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = '#fff')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = '#666')
                  }
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* ── Legal Column ── */}
          <div>
            <p
              style={{
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#444',
                marginBottom: '20px',
              }}
            >
              Legal
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              {legalLinks.map((item) => (
                <Link
                  key={item.href + item.label}
                  to={item.href}
                  style={{
                    fontSize: '14px',
                    color: '#666',
                    textDecoration: 'none',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = '#fff')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = '#666')
                  }
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* ── Suraksha Emergency Banner ── */}
        <div
          style={{
            backgroundColor: 'rgba(230,57,70,0.06)',
            border: '1px solid rgba(230,57,70,0.15)',
            borderRadius: '16px',
            padding: '24px 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '20px',
            marginBottom: '48px',
          }}
        >
          <div>
            <p
              style={{
                fontSize: '15px',
                fontWeight: '700',
                color: '#fff',
                marginBottom: '6px',
              }}
            >
              🚨 Suraksha — India's AI Anti-Fraud Protection App
            </p>
            <p style={{ fontSize: '13px', color: '#666' }}>
              Cyber fraud helpline:{' '}
              <a
                href="tel:1930"
                style={{
                  color: '#E63946',
                  fontWeight: '700',
                  textDecoration: 'none',
                }}
              >
                1930
              </a>{' '}
              — National Cybercrime Reporting Portal (Free, 24/7)
            </p>
          </div>
          <Link
            to="/suraksha"
            className="btn-primary"
            style={{
              padding: '10px 22px',
              fontSize: '14px',
              flexShrink: 0,
            }}
          >
            Learn About Suraksha →
          </Link>
        </div>

        {/* ── Newsletter / Stay Updated Strip ── */}
        <div
          style={{
            backgroundColor: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: '16px',
            padding: '24px 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '20px',
            marginBottom: '48px',
          }}
        >
          <div>
            <p
              style={{
                fontSize: '15px',
                fontWeight: '700',
                color: '#fff',
                marginBottom: '4px',
              }}
            >
              Stay updated on our products
            </p>
            <p style={{ fontSize: '13px', color: '#555' }}>
              HealHub updates · Suraksha launch · Vedant release
            </p>
          </div>
          <Link
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#fff',
              textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.12)',
              padding: '10px 20px',
              borderRadius: '50px',
              transition: 'all 0.2s',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor =
                'rgba(255,255,255,0.3)';
              e.currentTarget.style.background =
                'rgba(255,255,255,0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor =
                'rgba(255,255,255,0.12)';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            Get In Touch →
          </Link>
        </div>

        {/* ── Bottom Bar ── */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.06)',
            padding: '28px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          <p style={{ fontSize: '13px', color: '#444' }}>
            © {new Date().getFullYear()} Redcubical Systems Private
            Limited. All rights reserved.
          </p>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
              flexWrap: 'wrap',
            }}
          >
            <a
              href="https://healhub.in"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '13px',
                color: '#444',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = '#fff')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = '#444')
              }
            >
              HealHub.in ↗
            </a>
            <Link
              to="/about"
              style={{
                fontSize: '13px',
                color: '#444',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = '#fff')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = '#444')
              }
            >
              About
            </Link>
            <Link
              to="/contact"
              style={{
                fontSize: '13px',
                color: '#444',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = '#fff')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = '#444')
              }
            >
              Contact
            </Link>
          </div>
        </div>
      </div>

      {/* ── Responsive Styles ── */}
      <style>{`
        .footer-grid {
          grid-template-columns: 2fr 1fr 1fr 1fr;
        }
        @media (max-width: 900px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 560px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}